'use client';

import { isAdmin, isPro } from '@/lib/permissions';
import { useLoginRedirect } from '@/hooks/use-login-redirect';
import { useSession } from '@/hooks/use-session';
import TendersList, { type TendersResponse } from './components/tenders-list';

export default function TendersPageClient({
  initialData,
}: {
  initialData: TendersResponse | null;
}) {
  const { data: session, status } = useSession();
  const loginRedirect = useLoginRedirect();
  const isAuthenticated = status === 'authenticated';
  const isLoading = status === 'loading';
  const isGuest = !isLoading && !isAuthenticated;
  // Excel export is a Pro/Admin feature, same as /search. Non-entitled users
  // see the button but get a "Pro feature" prompt.
  const canExport = isAdmin(session) || isPro(session);

  return (
    <TendersList
      isGuest={isGuest}
      canExport={canExport}
      onSignIn={isGuest ? loginRedirect : undefined}
      initialData={initialData}
    />
  );
}
